import * as metaInterface from 'interfaces/meta.interface';

const initialMetaState: metaInterface.IInitialMetaState = {
  getConnections: () => Promise.resolve(false),
  isLoadingConnections: false,
  // Mappings
  mappings: [],
  getMaps: () => Promise.resolve(false),
  isLoadingMaps: false,
  mapSelected: null,
  setMapSelected: () => {},
  createMap: () => Promise.resolve(null),
  isLoadingCreateMap: false,
  deleteMap: () => Promise.resolve(false),
  isLoadingDeleteMap: {
    loading: false,
    mapId: '',
  },
  updateMap: () => Promise.resolve(false),
  isLoadingUpdateMap: false,
  addMapToConnection: () => Promise.resolve(false),
  isLoadingAddMapToConnection: false,
  deleteMapFromConnection: () => Promise.resolve(false),
  isLoadingDeleteMapFromConnection: false,
  addMapFieldsToMap: () => Promise.resolve(false),
  isLoadingAddMapFieldsToMap: false,
  // Map fields
  getMapFields: () => Promise.resolve(false),
  isLoadingMapFields: false,
  mapFields: [],
  createMapField: () => Promise.resolve(false),
  isLoadingCreateMapField: false,
  updateMapField: () => Promise.resolve(false),
  isLoadingUpdateMapField: false,
  deleteMapField: () => Promise.resolve(false),
  isLoadingDeleteMapField: {
    loading: false,
    mapFieldId: '',
  },
  deleteMapFields: () => Promise.resolve(false),
  isLoadingDeleteMapFields: false,
  removeMapFieldFromMap: () => Promise.resolve(false),
  removeMapFieldsFromMap: () => Promise.resolve(false),
  // Map fields templates
  getMapFieldsTemplates: () => Promise.resolve(false),
  isLoadingMapFieldsTemplates: false,
  mapFieldsTemplates: [],
  deleteMapFieldTemplate: () => Promise.resolve(false),
  isLoadingDeleteMapFieldTemplate: {
    loading: false,
    templateName: '',
  },
  copyMapFieldsTemplate: () => Promise.resolve(false),
  sftp: {
    connections: [],
    connectionSelected: null,
    setConnectionSelected: () => {},
    createSftpConnection: () => Promise.resolve(false),
    isLoadingCreateSftpConnection: false,
    updateSftpConnection: () => Promise.resolve(false),
    isLoadingUpdateSftpConnection: {
      connectionId: null,
      loading: false,
    },
    removeSftpConnection: () => {},
    isLoadingRemoveSftpConnection: {
      loading: false,
      user_name: '',
    },
  },
  shopify: {
    // Connections
    connections: [],
    connectionSelected: null,
    createShopifyConnection: () => Promise.resolve(false),
    isLoadingCreateShopifyConnection: false,
    updateShopifyConnection: () => Promise.resolve(false),
    isLoadingUpdateShopifyConnection: false,
    removeShopifyConnection: () => Promise.resolve(false),
    isLoadingRemoveShopifyConnection: {
      loading: false,
      connection_id: '',
    },
    // Queries
    getShopifyQueries: () => Promise.resolve(false),
    isLoadingQueries: false,
    queries: [],
    selectShopifyQuery: () => {},
    querySelected: null,
    createShopifyQuery: () => Promise.resolve(false),
    isLoadingCreateQuery: false,
    deleteShopifyQuery: () => Promise.resolve(false),
    isLoadingDeleteQuery: {
      loading: false,
      queryId: '',
    },
    updateShopifyQuery: () => Promise.resolve(false),
    isLoadingUpdateQuery: false,
    // Templates
    templates: [],
    getShopifyTemplates: () => Promise.resolve(false),
    isLoadingTemplates: false,
    selectShopifyTemplate: () => {},
    templateSelected: null,
    createUpdateShopifyTemplate: () => Promise.resolve(false),
    isLoadingCreateUpdateTemplate: false,
    deleteShopifyTemplate: () => Promise.resolve(false),
    isLoadingDeleteTemplate: {
      loading: false,
      templateTag: '',
    },
    // Configuration
    configuration: [],
    getShopifyConfiguration: () => Promise.resolve(false),
    isLoadingConfiguration: false,
    copyShopifyQueriesTemplate: () => Promise.resolve(false),
    isLoadingCreateUpdateConfiguration: false,
    addShopifyQueriesToConfiguration: () => Promise.resolve(false),
    isLoadingAddShopifyQueriesToConfiguration: false,
  },
};

export default initialMetaState;
